<template>
  <b-container class="main-container">
    <b-row v-for="(row,idx) in rows" :key="idx">
      <b-col class="photo-block-main" v-for="item in row" :key="item.id">
        <div class="photo-block" v-bind:style="item.thumbStyle">
          <div></div>
        </div>
      </b-col>
    </b-row>
    <!-- <div class="main-separator">
      <label>BEHIND THE LENS</label>
    </div>
    <b-row align-v="center">
      <b-col class="btl-photo" v-in-viewport.once>
        <img src="static/photos/main_alyson.jpg" />
      </b-col>
      <b-col>
        <h1>Artist</h1>
        <p>Besides photography, Alyson enjoys exercising, running, playing music, and spending time with her two crazy children.</p>
      </b-col>
    </b-row> -->
  </b-container>
</template>

<script>
import mainPhotos from '../assets/main.json'
export default {
  name: 'mainPhotos',
  data () {
    return {
      rows: [
        mainPhotos.slice(0, 3),
        mainPhotos.slice(3, 6),
        mainPhotos.slice(6, 9)
      ]
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.main-container {
  margin-top: 2em;
}

.photo-block-main:first-child {
  padding-right: 0;
}

.photo-block-main:nth-child(2) {
  padding: 0;
}

.photo-block-main:last-child {
  padding-left: 0;
}

.btl-photo {
  opacity: 0;
  transform: translate(-40px, -20px);
  transition: all ease 3s;
}

.btl-photo.in-viewport {
  transform: translate(0, 0);
  opacity: 1;
}

.btl-photo img {
  max-width: 100%;
}

.nopadding {
  padding: 0;
}

</style>



// WEBPACK FOOTER //
// src/components/Main.vue